import React from "react";

// package
import ReactGA from "react-ga4";
import TagManager from "react-gtm-module/dist/TagManager";
// css base
import CssBaseline from "@mui/material/CssBaseline";
// 語系
import IntlProviderHOC from "./i18n/IntlProviderHOC";
// auth
import FirebaseLayer from "./api/firebase/FirebaseLayer";
// 全域 theme
import CustomThemeProvider from "./theme/ThemeProvider";
// routes
import RouteManager from "./routes/RouteManager";
// component
import CommonNotify from "./pages/components/GlobalNotify";
import DebugMode from "./pages/components/DebugMode";
import ErrorCapture from "./pages/components/ErrorCapture";
import MainLoading from "./pages/components/MainLoading";
import NotifyRedux from "./pages/components/NotifyRedux";

const tagManagerArgs = {
  gtmId: process.env.REACT_APP_GTM_ID,
};
// Ga initialize
ReactGA.initialize(process.env.REACT_APP_GA_ID);
TagManager.initialize(tagManagerArgs);
//
function App() {
  return (
    <IntlProviderHOC>
      <CustomThemeProvider>
        <CssBaseline />
        <ErrorCapture>
          <FirebaseLayer>
            <CommonNotify />
            <NotifyRedux />
            <DebugMode />
            <MainLoading />
            <RouteManager />
          </FirebaseLayer>
        </ErrorCapture>
      </CustomThemeProvider>
    </IntlProviderHOC>
  );
}

export default App;
